// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__3WQ8u","menuList":"Menu_menuList__3rs_T","hideSmall":"Menu_hideSmall__2Mw8W","showFull":"Menu_showFull__2EdMF","hideLarge":"Menu_hideLarge__TkUiI"};